import marketService from 'services/market'
import { MarketBrief } from 'models/market'
import { formatNumber } from 'utils/format-number'
import { t9n } from 't9n/t9n'

let secondsToUpdate = 10

function checkTimer(): void {
  if (secondsToUpdate > 0) {
    secondsToUpdate--
    document.querySelector('[data-js-selector="rates-timer-wrapper"]').innerHTML = `${secondsToUpdate}`
  }
}

function getDirection(oldRate: number, newRate: number): string {
  if (oldRate - newRate > 0) {
    return 'is-down'
  } else if (oldRate - newRate === 0) {
    return 'is-neutral'
  }
  return 'is-up'
}

function setIconClass(element: Element, pair: MarketBrief): void {
  element
    .querySelector('[data-js-selector="rates-direction-icon"]')
    .setAttribute(
      'class',
      `bem-rate-table__icon ${getDirection(pair.directExchangeOffers.forexOld, pair.directExchangeOffers.forexNow)}`,
    )
}

function setRates(buyNow: number, sellNow: number, forexNow: number, element: Element): void {
  const $buyElement = element.querySelector('[data-rates-direction="buy"]')
  const $sellElement = element.querySelector('[data-rates-direction="sell"]')
  const $forexElement = element.querySelector('[data-rates-direction="forex"]')

  if ($buyElement) $buyElement.innerHTML = formatNumber(buyNow, 4)
  if ($sellElement) $sellElement.innerHTML = formatNumber(sellNow, 4)
  if ($forexElement) $forexElement.innerHTML = formatNumber(forexNow, 4)
}

function updateRates(): void {
  secondsToUpdate = 10
  const pairsPLN = marketService.getMarketBrief().filter((el) => el.pair.includes('PLN'))
  for (const pair of pairsPLN) {
    const { buyNow, sellNow, forexNow } = pair.directExchangeOffers
    const $row = document.querySelector(`[data-currency-id="${pair.pair}"]`)
    if ($row) {
      setRates(buyNow, sellNow, forexNow, $row)
      setIconClass($row, pair)
    }
  }
}

function handleError(): void {
  secondsToUpdate = 10
  document.querySelector('[data-js-selector="rates-timer-wrapper"]').parentElement.innerHTML = `${t9n(
    'ratesUpdate.error',
  )} <strong data-js-selector="rates-timer-wrapper">10</strong> ${t9n('ratesUpdate.timeUnit')}`
}

export default function initRates() {
  setInterval(checkTimer, 1 * 1000) // 1 second
  window.addEventListener('marketBrief fetched', updateRates)
  window.addEventListener('marketBrief fetch fail', handleError)
}
